import {
  CreateNewInviteLink,
  DeleteInviteLinks,
  EditInviteLink,
  GetAllInviteLinks,
  GetInviteLinkUsages,
  InviteLink,
  reqCreateNewInviteLink,
  reqDeleteInviteLinks,
  reqEditInviteLink,
  reqGetAllInviteLinks,
  reqGetInviteLinkUsages,
  reqRevokeInviteLink,
  RevokeInviteLink,
} from '@weblite/ts-action/hall'
import { Timestamp } from '@weblite/ts-action/types'
import { request } from '$setup/ws'
import { hallInviteLinkStorage } from './invite-link.storage'
import { HallInviteLink } from './types'

// TODO: get all options as one arg with InviteLinkOptions type

function getHallInviteLinkId(link: string, roomId: string) {
  return link + roomId
}
export async function createNewInviteLink(
  roomId: string,
  expiresAt: Timestamp,
  usageLimit: number,
): Promise<HallInviteLink | null> {
  const res = await request<CreateNewInviteLink>(
    reqCreateNewInviteLink({ roomId, expiresAt, usageLimit }),
  )
  if (res.error) return null
  hallInviteLinkStorage.add([
    {
      ...res.payload,
      id: getHallInviteLinkId(res.payload.link, roomId),
    },
  ])
  return {
    ...res.payload,
    id: getHallInviteLinkId(res.payload.link, roomId),
  }
}

export async function getAllInviteLinks(roomId: string) {
  const res = await request<GetAllInviteLinks>(reqGetAllInviteLinks({ roomId }))
  if (res.error) return null

  return res.payload.inviteLinks.map(inviteLink => ({
    ...inviteLink,
    id: getHallInviteLinkId(inviteLink.link, inviteLink.roomId),
  }))
}

export async function revokeInviteLink(
  roomId: string,
  link: string,
): Promise<boolean> {
  const res = await request<RevokeInviteLink>(
    reqRevokeInviteLink({ roomId, link }),
  )

  if (res.error) return false
  hallInviteLinkStorage.update(getHallInviteLinkId(link, roomId), {
    isRevoked: true,
  })
  return true
}

export async function deleteInviteLinks(
  roomId: string,
  links: string[],
): Promise<boolean> {
  const res = await request<DeleteInviteLinks>(
    reqDeleteInviteLinks({ roomId, links }),
  )

  if (res.error) return false

  links.forEach(link => {
    hallInviteLinkStorage.del(getHallInviteLinkId(link, roomId))
  })

  return true
}

export async function editInviteLink(
  roomId: string,
  link: string,
  expiresAt: Timestamp,
  usageLimit: number,
): Promise<InviteLink | null> {
  const res = await request<EditInviteLink>(
    reqEditInviteLink({ roomId, link, expiresAt, usageLimit }),
  )
  if (res.error) return null
  hallInviteLinkStorage.update(
    getHallInviteLinkId(res.payload.link, roomId),
    res.payload,
  )
  return res.payload
}

export function isExpired({ expiresAt }: InviteLink) {
  return expiresAt && new Date() > new Date(expiresAt)
}

export function hasReachedLimit({ usage, usageLimit }: InviteLink) {
  return usageLimit && usage >= usageLimit
}

export async function searchInJoinedViaLinkMembers(
  roomId: string,
  link: string,
  query?: string,
  pageToken?: string,
) {
  const res = await request<GetInviteLinkUsages>(
    reqGetInviteLinkUsages({ roomId, link, pageToken, query }),
  )
  if (res.error) return null
  return res.payload
}

export async function getJoinedViaLinkMembers(
  roomId: string,
  link: string,
  pageToken?: string,
) {
  return searchInJoinedViaLinkMembers(roomId, link, undefined, pageToken)
}
